import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Col, Form, Input, Modal, Row, Select } from 'antd';
import Title from 'antd/es/typography/Title';
import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { getCheckInType } from 'app/entities/common/common.reducer';
import { getKrCheckInQuanti } from 'app/entities/progress-log/progress-log.reducer';
import TableComponent from 'app/shared/component/table/table';
import { filterOption } from 'app/shared/util/select-filter';
import dayjs from 'dayjs';
import { columnsQuanti } from './config';

type IReportQuantitativeResultView = {
  isOpen: boolean;
  onClose: (isReload?: boolean) => void;
  idKrSelected: string;
};

export const ReportQuantitativeResultView = ({ isOpen, onClose, idKrSelected }: IReportQuantitativeResultView) => {
  const dispatch = useAppDispatch();
  const progressLog = useAppSelector(state => state.progressLog.entity);
  const checkInTypes = useAppSelector(state => state.common.checkInTypes);
  const [checkInType, setCheckInType] = useState(null);

  useEffect(() => {
    innitData();
  }, [idKrSelected]);

  useEffect(() => {
    if (checkInType !== null) {
      dispatch(getKrCheckInQuanti({ id: idKrSelected, checkInDetailBy: checkInType }));
    }
  }, [checkInType]);

  useEffect(() => {
    if (checkInTypes.length > 0) {
      setCheckInType(checkInTypes[0].value);
    }
  }, [checkInTypes]);

  const innitData = () => {
    if (idKrSelected) {
      dispatch(getCheckInType());
    }
  };

  const handleClose = () => {
    onClose();
  };

  const handleChangeCheckInType = (value) => {
    setCheckInType(value);
  }

  return (
    <Modal
      width={1300}
      open={isOpen}
      footer={null}
      onCancel={() => {
        handleClose();
      }}
    >
      <div className="view">
        <Row>
          <Col md={6}>
            <Title level={3}>Kết quả thực hiện KR</Title>
          </Col>
          <Col md={1} />
          <Col>
            <Select
              allowClear
              value={checkInType}
              showSearch
              onChange={handleChangeCheckInType}
              size="large"
              filterOption={filterOption}
              options={checkInTypes}
              placeholder="Chọn kỳ kế hoạch"
            />
          </Col>
        </Row>
        <Row>
          <Col md={2}>
            <Form.Item label="Mã KR" >
              <Input disabled size="large" value={progressLog?.code} />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={3}>
            <Form.Item label="Ngày bắt đầu" >
              <Input disabled size="large" value={progressLog?.startDate ? dayjs(progressLog?.startDate).format(APP_LOCAL_DATE_FORMAT) : undefined} />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={3}>
            <Form.Item label="Thời hạn hoàn thành">
              <Input disabled size="large" value={progressLog?.dueDate ? dayjs(progressLog?.dueDate).format(APP_LOCAL_DATE_FORMAT) : undefined} />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item label="Chỉ tiêu" >
              <Input disabled size="large" value={progressLog?.metricName} />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={2}>
            <Form.Item label="Chỉ số cả năm" >
              <Input disabled size="large" value={progressLog?.metricValue} />
            </Form.Item>
          </Col>
          <Col md={1} />
          <Col md={4}>
            <Form.Item label="Đơn vị tính" >
              <Input disabled size="large" value={progressLog?.metricUnit} />
            </Form.Item>
          </Col>
        </Row>
        <div className="table">
          <TableComponent
            data={progressLog?.checkins?.map((x, index) => {
              return {
                key: index + 1,
                ...x,
              };
            })}
            scroll={true}
            total={0}
            tableLayout={'fixed'}
            isFetching={false}
            columns={columnsQuanti}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ReportQuantitativeResultView;
